// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__Kxohb","map":"Summary_map__rE214"};